/**
 * Class added to markdown chart containers while they are rendering in headless mode.
 * Removed once the Highcharts 'load' event fires, indicating the chart is fully rendered.
 * Used by waitForAppQuiescence() to determine when all charts are ready for PDF capture.
 */
export const HEADLESS_CHART_RENDERING_CLASS = 'markdownChartRendering';
